import { useEffect, useState } from "react";
import Layout from "../../Layout";
import DeviceService from "../../Services/DeviceService";
import { Flex, Spin } from "antd";
import nodatafound from "../../assets/images/Svg/nodatafound.svg";
import { useSelector } from "react-redux";

function PatientDevices() {
  const [devicesList, setDevicesList] = useState([]);
  const [loading, setLoading] = useState(true);
  let { patientData } = useSelector((state) => state.auth);

  useEffect(() => {
    getPatientDevices();
  }, []);

  const getPatientDevices = async () => {
    let payload = {
      patientCode: patientData?.patientId,
      status: 1,
    };

    try {
      let result = await DeviceService.GetPatientDevices(payload);
      if (result?.data?.data) {
        setDevicesList(result.data.data);
      } else {
        setDevicesList([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="h-[300px] flex items-center justify-center mt-[10%]">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="loading" />
          </Flex>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mx-auto w-[80%]">
        {devicesList && devicesList.length > 0 ? (
          <table className="min-w-full border border-gray-200 shadow-md rounded-md customTable my-10">
            <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
              <tr>
                <th className="p-3 whitespace-nowrap">Code</th>
                <th className="p-3 whitespace-nowrap">Name</th>
                <th className="p-3 whitespace-nowrap">Brand</th>
                <th className="p-3 whitespace-nowrap">Model</th>
                <th className="p-3 whitespace-nowrap">Description</th>
                <th className="p-3 whitespace-nowrap">Active/Inactive</th>
              </tr>
            </thead>

            <tbody className="text-sm">
              {devicesList.map((record, index) => (
                <tr
                  key={index}
                  className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                >
                  <td className="p-3 whitespace-nowrap">{record.deviceCode}</td>
                  <td className="p-3 whitespace-nowrap">{record.deviceName}</td>
                  <td className="p-3 whitespace-nowrap">
                    {record.deviceBrand}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {record.deviceModel}
                  </td>
                  <td className="p-3">{record.deviceDescription}</td>
                  <td className="p-3 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={record.status === 1}
                      readOnly
                      className="w-4 h-4"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="flex flex-col items-center mt-2 justify-center">
            <img src={nodatafound} alt="nodatafound" className="h-min w-min" />
            <p className="font-medium text-xl">No Devices Mapped</p>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default PatientDevices;
